import { AttachFile } from "@material-ui/icons";
import { Clear } from "@mui/icons-material";
import {
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useEffect, useState } from "react";
import Moment from "react-moment";

import {
  downloadFileRevisionMulti,
  downloadFileRevisionSingle,
} from "../../api/FileRevision";
import {
  IFileData,
  NewIDataUploadItem,
} from "../../interfaces/IDataUploadItem";
import { ISharepointState } from "../../interfaces/ISharepointState";
import { getSharepointToken } from "../../pages/view-form/api-endpoint/callApi";
import { RoleStatus } from "../../shared/Enum/RoleStatus";
import UploadMultipleFileComponent from "../uploadmultiplefile/UploadMultipleFile";

export default function RevisionDisabledComponent({ allObj }) {
  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const [loadingActive, setLoadingActive] = useState(false);

  const [dataUpload, setDataUpload] = useState<NewIDataUploadItem[]>([
    {
      title: "Bukti / Evidence",
      fileType: "Evidence",
      files: [{ documentID: "", fileBase64: "", fileName: "", folderName: "" }],
    },
  ]);

  const [sharepoint, setSharepoint] = useState<ISharepointState>({
    token: "",
    expToken: new Date(),
  });

  const ensureValidToken = async () => {
    const currentTime = new Date();
    const differenceInMinutesTokenSharepoint =
      (sharepoint.expToken.getTime() - currentTime.getTime()) / 1000 / 60;

    if (differenceInMinutesTokenSharepoint < 10) {
      const tokenSharepoint = await getSharepointToken();
      const newExpTime = new Date(currentTime.getTime() + 30 * 60 * 1000);

      setSharepoint({
        ...sharepoint,
        token: tokenSharepoint.token,
        expToken: newExpTime,
      });

      return tokenSharepoint.token;
    }

    return sharepoint.token;
  };

  const handleChangeDownload = async (dataIndex, fileIndex) => {
    const getDataUpload = [...dataUpload];
    const downloadLink = document.createElement("a");
    const currentFileData = getDataUpload[dataIndex].files[fileIndex];

    const downloadFile = async () => {
      try {
        if (!currentFileData.documentID) {
          console.warn("No Document ID provided for download.");
          return null;
        }

        const token = await ensureValidToken();

        // Download file based on Old Document
        if (currentFileData.documentID.startsWith("RV")) {
          return await downloadFileRevisionSingle({
            documentName: currentFileData.fileName,
            revisionID: allObj.revisionID,
            sharepointToken: token,
          });
        }

        // Download file based on New Document
        return await downloadFileRevisionMulti({
          documentName: currentFileData.fileName,
          revisionID: allObj.revisionID,
          sharepointToken: token,
        });
      } catch (error) {
        console.error("Error downloading file:", error);
        return null;
      }
    };

    try {
      setLoadingActive(true);
      const tempBase64File = await downloadFile();

      if (tempBase64File) {
        if (currentFileData.documentID !== "") {
          currentFileData.fileBase64 = tempBase64File;
        }

        // Download the file
        downloadLink.href = tempBase64File;
        downloadLink.download = currentFileData.fileName;
        downloadLink.click();
      }
    } catch (error) {
      console.error("Error processing download:", error);
    } finally {
      setLoadingActive(false);
    }
  };

  useEffect(() => {
    const defaultData: IFileData[] = [];
    allObj.files.map((e) => {
      defaultData.push({
        documentID: e.documentID,
        fileName: e.documentName,
        folderName: e.link,
        fileBase64: "",
      });
    });
    setDataUpload([
      {
        title: "Bukti / Evidence",
        fileType: "Evidence",
        files: defaultData,
      },
    ]);
  }, []);

  return (
    <>
      {loadingActive && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          marginY: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: { xs: "flex-start", sm: "space-between" },
            alignItems: "center",
            gap: 1,
            marginBottom: 1,
          }}
        >
          <Typography variant="subtitle1" style={{ marginTop: "0.55%" }}>
            {allObj.fromRole == RoleStatus.toId(RoleStatus.EndUser) ? (
              <>
                <i>
                  <Moment format="dddd,">{allObj.dateIn}</Moment>
                </i>{" "}
                <Moment format="MMMM DD, YYYY,">{allObj.dateIn}</Moment> -
                Requestor
              </>
            ) : (
              <>
                <i>
                  <Moment format="dddd,">{allObj.dateIn}</Moment>
                </i>{" "}
                <Moment format="MMMM DD, YYYY,">{allObj.dateIn}</Moment> -
                Corporate Legal
              </>
            )}
          </Typography>
          {dataUpload[0].files.length > 0 && (
            <Button
              onClick={() => setOpenPreviewDialog(true)}
              style={{ textTransform: "none", color: "white" }}
              variant="contained"
            >
              <Typography variant="subtitle1">View</Typography>
            </Button>
          )}
        </Box>
        <div
          style={{
            padding: "10px 16px",
            backgroundColor: "#d6d6d6",
            borderRadius: 7,
            border: "1px solid gray",
            borderColor: "#9f9f9f",
            fontSize: "14px",
            color: "#858585",
          }}
        >
          <div style={{ whiteSpace: "pre-wrap" }}>{allObj.note}</div>
        </div>
      </Box>
      <Dialog open={openPreviewDialog} maxWidth={false}>
        <DialogTitle
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "1rem 2rem",
          }}
        >
          <div style={{ display: "flex" }}>
            <Typography style={{ marginRight: "0.5rem" }}>
              Request Detail:
            </Typography>
            <Typography style={{ fontWeight: 700 }}>
              {allObj.requestNumber}
            </Typography>
          </div>
          <Box
            display="flex"
            sx={{ cursor: "pointer" }}
            onClick={() => setOpenPreviewDialog(false)}
          >
            <Clear />
          </Box>
        </DialogTitle>
        <DialogContent
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            padding: "2rem",
            paddingTop: "1rem",
            minWidth: "50vw",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "1rem",
            }}
          >
            <div style={{ rotate: "45deg", marginRight: "0.5rem" }}>
              <AttachFile />
            </div>
            <Typography>Attachment</Typography>
          </div>
          {dataUpload.map((obj, i) => (
            <div
            // style={{
            //   width: window.innerWidth * 0.35,
            // }}
            >
              <UploadMultipleFileComponent
                disabled
                file={obj}
                fileIndex={i}
                onUploadFile={() => {}}
                onDeleteFile={() => {}}
                onDownloadFile={(fileIndex) => {
                  handleChangeDownload(i, fileIndex);
                }}
                onAddMoreData={() => {
                  if (dataUpload[i].files.length < 5) {
                    setDataUpload((prevState) => {
                      const newState = [...prevState];
                      const emptyFile = {
                        documentID: "",
                        fileBase64: "",
                        fileName: "",
                        folderName: "",
                      };
                      if (i >= 0 && i < newState.length) {
                        newState[i].files.push(emptyFile);
                      }

                      return newState;
                    });
                  }
                }}
                onDeleteData={() => {}}
                requiredValidationMessage=""
              />
            </div>
          ))}
        </DialogContent>
      </Dialog>
    </>
  );
}
